import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');

const Input = styled.input`
  background-color: ${colors.white};
  border-radius: 3px;
  border: solid 1px ${colors.N40};
  box-sizing: border-box;
  color: ${colors['near-white']};
  font-size: 14px;
  height: 24px;
  letter-spacing: -0.3px;
  line-height: 1.14;
  padding: 0 8px;

  &::placeholder {
    color: ${colors.N200};
  }
`;

export default Input;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/Input.js